module.exports = __webpack_public_path__ + "img/28.71252792.png";